module.exports = "/_next/static/images/SafariEnableMediaRecorder1-4093c4975ad4dd5ae2acad62ddd6db57.png";